import { jsx as _jsx } from "react/jsx-runtime";
import { PendingButton } from "@ploy-ui/core";
import { download, getFilenameFromResponse, apiResourceUrl } from "@ploy-lib/core";
const ExportWholesaleLimitButton = (props) => {
    const { details = false, vendorId, label } = props;
    const url = details
        ? `/wholesaleLimit/${vendorId}/detail/ExportToExcel`
        : `/wholesaleLimit/${vendorId}/ExportToExcel`;
    return vendorId ? (_jsx(PendingButton, { onClick: async () => {
            const response = await fetch(apiResourceUrl(url));
            if (!response.ok) {
                throw new Error("En feil har oppstått.");
            }
            const filename = getFilenameFromResponse(response) ?? "Excel.xlsx";
            const blob = await response.blob();
            download(new File([blob], filename));
        }, color: "secondary", variant: "contained", children: label })) : null;
};
export { ExportWholesaleLimitButton };
//# sourceMappingURL=ExportWholesaleLimitButton.js.map